/* eslint-disable max-len */
import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import styled from 'styled-components';

import api from '../../services/api';

import ChangePageAnimation from '../ChangePageAnimation';
import PopUp from '../PopUp';
import Logo from './Logo';
import Menu from './Menu';
// import StyledBlueCircle from './StyledBlueCircle';
import BluePointsBlock from './BluePointsBlock';
import bluePointsAnimationStates from './BluePointsBlock/animationStates';

import Main from '../../pages/Main';
import Direction from '../../pages/Direction';
import Contacts from '../../pages/Contacts';
import PhaserComponent from '../PhaserComponent';
import phaserComponentStates, { getPhaserComponentInitialState } from '../PhaserComponent/phaserComponentStates';
// import phaserComponentStates from '../PhaserComponent/phaserComponentStates';
import NotFoundPage from '../../pages/NotFoundPage';

import Color from '../../utils/colors';

import Links from '../../utils/links';
import Team from '../../pages/Team';

import anchorScroll from '../../utils/anchorScroll';

import { addData } from '../../utils/directionsData';
import RazorAndBlade from '../../pages/RazorAndBlade';

export default class PagesContainer extends Component {
    constructor(props) {
        super(props);
        this.scrollContentRef = React.createRef();

        const phaserComponentState = getPhaserComponentInitialState();

        this.state = {
            // phaserComponentState: phaserComponentStates.HIDE,
            // phaserComponentState: phaserComponentStates.GAME,
            phaserComponentState,
            bluePointsAnimationState: phaserComponentState === phaserComponentStates.GAME ? bluePointsAnimationStates.LOGO_POSITION : bluePointsAnimationStates.NONE,
            isMazeAnimate: true,
            dataIsLoad: false,
            pageChanging: {
                isChangePage: false,
                to: null,
            },
            popUp: {
                isImages: false,
                isShow: false,
                component: null,
                componentProps: null,
                positionY: 0,
            },
        };

        this.isRsize = false;
        this.localCallBackCLosePopup = null;

        this.containerRef = React.createRef();
        this.handleResize = this.handleResize.bind(this);
        this.scrollToForm = this.scrollToForm.bind(this);
        this.handleOpenPopUp = this.handleOpenPopUp.bind(this);
        this.handleCloseGame = this.handleCloseGame.bind(this);
        this.handleClosePopUp = this.handleClosePopUp.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangePageAnimationEnd = this.handleChangePageAnimationEnd.bind(this);
        this.handleChangeBluePointsAnimation = this.handleChangeBluePointsAnimation.bind(this);
    }

    componentDidMount() {
        // initUser();
        api.getAllDirections()
            .then(({ data: directions }) => this.setState({ dataIsLoad: addData(directions) }));

        window.addEventListener('resize', this.handleResize);
    }

    scrollToForm() {
        anchorScroll(this.scrollContentRef);
    }

    handleChangePage(to = null) {
        this.setState({
            isMazeAnimate: true,
            pageChanging: {
                isChangePage: true,
                to,
            },
        });
    }

    handleChangePageAnimationEnd() {
        this.setState({
            pageChanging: {
                isChangePage: false,
                to: null,
            },
        });
    }

    handleOpenPopUp(component = null, props = null, isPopupWithImages = false) {
        const { popUp } = this.state;
        if (!isPopupWithImages) this.containerRef.current.style.top = `-${window.scrollY}px`;
        document.body.style.minHeight = `${window.innerHeight}px`;
        // document.body.style.overflowY = 'hidden';
        // alert(`${window.innerHeight} / ${window.outerHeight}`);

        if (popUp.component) {
            this.localCallBackCLosePopup = () => this.setState({
                popUp: {
                    isImages: isPopupWithImages,
                    isShow: Boolean(component),
                    component,
                    componentProps: props,
                    positionY: window.scrollY,
                    callbackClose: props.callbackClose,
                },
            }, () => {
                this.localCallBackCLosePopup = null;
            });

            this.handleClosePopUp();
        } else {
            this.setState({
                popUp: {
                    isImages: isPopupWithImages,
                    isShow: Boolean(component),
                    component,
                    componentProps: props,
                    positionY: window.scrollY,
                    callbackClose: props.callbackClose,
                },
            });
        }
    }

    handleClosePopUp(customScroll, withCallback = true) {
        const { popUp: { positionY, isImages, callbackClose } } = this.state;
        let scrollTo = 0;
        if (customScroll === 'toTop') {
            scrollTo = 0;
        } else {
            scrollTo = positionY;
        }
        this.containerRef.current.style = {};
        this.setState(
            {
                popUp: { isShow: false, content: null, componentProps: null },
            }, () => {
                if (!isImages) window.scrollTo(0, scrollTo);
                if (withCallback && callbackClose && typeof callbackClose === 'function') callbackClose();
                if (this.localCallBackCLosePopup) this.localCallBackCLosePopup();
            },
        );
    }

    handleCloseGame(phaserState) {
        this.setState({ phaserComponentState: phaserState, isMazeAnimate: false });
    }

    handleChangeBluePointsAnimation(state) {
        this.setState({ bluePointsAnimationState: state });
    }

    handleResize() {
        if (!this.isRsize) {
            this.isRsize = true;
            setTimeout(() => {
                this.forceUpdate();
                this.isRsize = false;
            }, 10);
        }
    }

    render() {
        const {
            dataIsLoad,
            phaserComponentState,
            isMazeAnimate,
            pageChanging: {
                isChangePage,
                to,
            },
            popUp: {
                isImages,
                isShow: isShowPopUp,
                component: popUpComponent,
                componentProps,
            },
            bluePointsAnimationState,
        } = this.state;

        return (
            phaserComponentState === phaserComponentStates.GAME && window.location.pathname !== '/' ? <Redirect to="/" />
                : (
                    <Container
                        isShowPopUp={isShowPopUp}
                        isShowPopupWithImages={isImages}
                        isShowGame={phaserComponentState === phaserComponentStates.GAME}
                        ref={this.containerRef}
                    >
                        {
                            phaserComponentState !== phaserComponentStates.HIDE && (
                                <PhaserComponent
                                    phaserComponentState={phaserComponentState}
                                    handleCloseGame={(phaserState) => this.handleCloseGame(phaserState)}
                                    handleChangeBluePointsAnimation={this.handleChangeBluePointsAnimation}
                                    isChangePage={isChangePage}
                                    to={to}
                                />
                            )
                        }
                        {
                            phaserComponentState !== phaserComponentStates.GAME && dataIsLoad && (
                                <Switch>
                                    <Route
                                        exact
                                        path={Links.MAIN}
                                        render={(props) => (
                                            <Main
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                                {...props}
                                                handleOpenPopUp={this.handleOpenPopUp}
                                                handleChangePage={this.handleChangePage}
                                                scrollRef={this.scrollContentRef}
                                                scrollToForm={this.scrollToForm}
                                                isMazeAnimate={isMazeAnimate}
                                            />
                                        )}
                                    />
                                    <Route
                                        exact
                                        path={Links.TEAM}
                                        render={() => (
                                            <Team
                                                handleChangePage={this.handleChangePage}
                                                scrollRef={this.scrollContentRef}
                                            />
                                        )}
                                    />
                                    <Route
                                        exact
                                        path={Links.DIRECTION}
                                        render={(props) => (
                                            <Direction
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                                {...props}
                                                handleOpenPopUp={this.handleOpenPopUp}
                                                handleChangePage={this.handleChangePage}
                                                scrollRef={this.scrollContentRef}
                                                scrollToForm={this.scrollToForm}
                                            />
                                        )}
                                    />
                                    <Route
                                        exact
                                        path={Links.CONTACTS}
                                        render={() => (
                                            <Contacts
                                                handleChangePage={this.handleChangePage}
                                                scrollRef={this.scrollContentRef}
                                            />
                                        )}
                                    />
                                    <Route
                                        exact
                                        path={Links.MILESTONES}
                                        render={() => (
                                            <RazorAndBlade
                                                handleChangePage={this.handleChangePage}
                                                handleOpenPopUp={this.handleOpenPopUp}
                                                scrollRef={this.scrollContentRef}
                                            />
                                        )}
                                    />
                                    {/* <Route exact path="/test" component={TestPage} /> */}
                                    <Route exact path="*" component={NotFoundPage} />
                                </Switch>
                            )
                        }
                        {
                            isChangePage && (
                                <ChangePageAnimation
                                    to={to}
                                    handleChangePageAnimationEnd={this.handleChangePageAnimationEnd}
                                />
                            )
                        }
                        <BluePointsBlock animationState={bluePointsAnimationState} />
                        {
                            phaserComponentState !== phaserComponentStates.GAME && (
                                <>
                                    <Logo
                                        handleChangePage={this.handleChangePage}
                                    />
                                    <Menu
                                        onClick={this.handleOpenPopUp}
                                        handleChangePage={this.handleChangePage}
                                        scrollToForm={this.scrollToForm}
                                    />
                                </>
                            )
                        }
                        {/* {
                            !isShowGame && (
                                <>
                                    <Logo
                                        handleChangePage={this.handleChangePage}
                                    />
                                    <Menu
                                        onClick={this.handleOpenPopUp}
                                        handleChangePage={this.handleChangePage}
                                        scrollToForm={this.scrollToForm}
                                    />
                                    <StyledBlueCircle isLeft />
                                    <StyledBlueCircle />
                                </>
                            )
                        } */}
                        {
                            isShowPopUp && (
                                <PopUp
                                    popUpComponent={popUpComponent}
                                    componentProps={componentProps}
                                    handleClosePopUp={this.handleClosePopUp}
                                    handleOpenPopUp={this.handleOpenPopUp}
                                    scrollToForm={this.scrollToForm}
                                />
                            )
                        }
                    </Container>
                )
        );
    }
}

const Container = styled.div`
    width: 100%;
    height: ${({ isShowGame }) => (isShowGame ? `${window.innerHeight}px` : 'auto')};
    position: ${({ isShowPopUp, isShowPopupWithImages }) => (
    // eslint-disable-next-line no-nested-ternary
        isShowPopUp ? (isShowPopupWithImages ? 'relative' : 'fixed') : 'relative'
    )};
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    overflow: hidden;

    background-color: ${Color.PRIMARY}; //game background
`;
